// @flow
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Item from '../../../Item/Item';
import classNames from 'classnames/bind';
import moment from 'moment';

import style from '../Reception.scss';
import icons from '../../../../../assets/styles/icons.scss';

import type {
  Address, OrderItem,
  Shipment,
  ShipmentItem, ShipmentOrder, ShippingIdentity, User,
} from '../../../../../entities';


type Props = {
  +receptionOrder: ShipmentOrder;
  +isReceivingOrderItemMap: { [key: string]: boolean };
  +handleOpenModal: (
    purchaser: User,
    shippingIdentity: ShippingIdentity,
    shippingAddress: Address,
    shipments: Shipment[],
    orderId: string,
  ) => void;
  +handleReceiveProduct: (orderId: string, orderItemId: number) => void;
  +receptionCountMap: { [key: string]: string };
};

export default class ReceptionOrder extends PureComponent<Props> {

  shouldNotRender = (): boolean =>
    this.props.receptionOrder.items.reduce((received, orderItem: OrderItem) =>
      orderItem.amount === orderItem.receivedCount
      , true);

  buildDate = (paidAt: number) => {
    if (moment(paidAt).isBefore(moment().subtract(30, 'day'), 'day')) {
      return (
        <div className={style.dateWrap}>
          <FormattedMessage id="courier.reception.updatedAt">{
            txt => <p>{txt}:&nbsp;</p>
          }</FormattedMessage>
          <i className={icons.symbolWarning}/>&nbsp;
          <p className={style.warning}>
            {moment(paidAt).utc().format('DD/MM/YY')}
          </p>&nbsp;
          <i className={icons.symbolWarning}/>
        </div>);
    } else {
      return (
        <FormattedMessage id="courier.reception.updatedAt">{
          txt => <p>{txt}:&nbsp;
            <span>{moment(paidAt).utc().format('DD/MM/YY')}</span>
          </p>
        }</FormattedMessage>);
    }
  }

  render() {
    const {
      receptionOrder,
      isReceivingOrderItemMap,
      handleOpenModal,
      handleReceiveProduct,
      receptionCountMap,
    } = this.props;
    if (this.shouldNotRender()) return null;
    return (
      <div className={classNames(style.orderWrap, {
        [style.loading]: isReceivingOrderItemMap[receptionOrder.id],
      })}>
        <div className={style.top}>
          <div className={style.orderIdWrap}>
            <p>{receptionOrder.id}</p>
            <p>{receptionOrder.state}</p>
            {/*<FormattedMessage id="courier.reception.state">{
                      txt => <p>{txt}</p>
                    }</FormattedMessage>*/}
          </div>
          <div className={style.date}>
            {this.buildDate(receptionOrder.paidAt)}
          </div>
          {/*<div className={style.details}>
                    <FormattedMessage id="courier.reception.itemTotal">{
                      txt => <p>{txt}:&nbsp;<span>
                                          $ {CommaFormat({ price: receptionOrder.invoice.total })}
                                        </span></p>
                    }</FormattedMessage>
                    <FormattedMessage id="courier.reception.commission">{
                      txt => <p>{txt}:&nbsp;<span>
                                          $ {receptionOrder.invoice.commission}
                                      </span></p>
                    }</FormattedMessage>
                  </div>*/}
          <div className={style.purchaser}>
            <FormattedMessage id="courier.reception.purchaser.information">{
              txt => <p>{txt}:</p>
            }</FormattedMessage>
            <a className={style.modalOpener}
               onClick={() => handleOpenModal(
                 receptionOrder.purchaser,
                 receptionOrder.shippingIdentity,
                 receptionOrder.shippingAddress,
                 receptionOrder.shipments,
                 receptionOrder.id,
               )}>
              {receptionOrder.purchaser.firstName} {receptionOrder.purchaser.lastName}
            </a>
          </div>
        </div>
        <div className={style.tableWrap}>
          <table>
            <tbody>
            {receptionOrder.shipments.map((shipment: Shipment, key: number) =>
              (<Fragment key={key}>
                {shipment.deliveryDate ?
                  <tr>
                    <td>
                      <FormattedMessage id="courier.reception.deliveryDate">{
                        txt => <p className={style.deliveryDate}>{txt}:</p>
                      }</FormattedMessage>
                      <p className={style.deliveryDate}>
                        {moment(shipment.deliveryDate).utc().format('DD/MM/YY')}
                      </p>
                    </td>
                  </tr> :
                  receptionOrder.beforeDate ?
                    <tr>
                      <td>
                        <FormattedMessage id="courier.reception.deliveryDate">{
                          txt => <p className={style.deliveryDate}>{txt}:</p>
                        }</FormattedMessage>
                        <p className={style.deliveryDate}>
                          {moment(receptionOrder.beforeDate).utc().format('DD/MM/YY')}
                        </p>
                      </td>
                    </tr> : ''}
                {!shipment.deliveryDate &&
                !receptionOrder.beforeDate &&
                receptionOrder.state === 'IN_COURIER_FLOW' &&
                <tr>
                  <td>
                    <FormattedMessage id="courier.reception.unconfirmed">{
                      txt => <p className={style.deliveryDate}>{txt}</p>
                    }</FormattedMessage>
                  </td>
                </tr>}
                {shipment.items.map((shipmentItem: ShipmentItem, index: number) =>
                  <Item
                    key={`orderItem-${index}`}
                    orderId={receptionOrder.id}
                    shipmentItem={shipmentItem}
                    handleReceiveProduct={handleReceiveProduct}
                    isReceived={
                      receptionCountMap[shipmentItem.orderItem.orderItemId] === shipmentItem.orderItem.amount
                    }
                  />)}
              </Fragment>))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

ReceptionOrder.propTypes = {
  receptionOrder: PropTypes.object.isRequired,
  isReceivingOrderItemMap: PropTypes.object.isRequired,
  handleOpenModal: PropTypes.func.isRequired,
  handleReceiveProduct: PropTypes.func.isRequired,
  receptionCountMap: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/modules/courier/recepetion/components/ReceptionOrder/ReceptionOrder.jsx